/**
 * Cross-app navigation helper.
 *
 * The vault owner / heir experience was split out of the advisor app into the
 * standalone `apps/vault` SPA, served on its own hosting site
 * (`VITE_VAULT_PORTAL_BASE_DOMAIN`). Advisor-app links/redirects that used to
 * point at the in-app `/vault/*` routes now target that separate origin, using
 * the vault app's own (un-prefixed) paths — e.g. the old `/vault/signin` is the
 * vault app's `/`, and `/vault/settings/user/profile` is `/settings/profile`.
 *
 * When the base domain is unset (local dev), we fall back to a relative `/vault`
 * prefix so links still resolve behind a single-origin dev proxy.
 */
const BASE_DOMAIN = import.meta.env.VITE_VAULT_PORTAL_BASE_DOMAIN;

export const VAULT_APP_ORIGIN = BASE_DOMAIN
  ? `https://${BASE_DOMAIN}`
  : "/vault";

/** Build an absolute (or dev-relative) URL into the standalone vault app. */
export function vaultAppUrl(path: string = "/"): string {
  const suffix = path === "/" ? "" : path;
  return `${VAULT_APP_ORIGIN}${suffix}`;
}
